type DurationUnit = "second" | "minute" | "hour" | "day" | "month" | "year";

const formatDuration = (
  durationInSeconds: number,
  durationUnit?: DurationUnit | string
): [number, string] => {
  const secondsInMinute = 60;
  const secondsInHour = 60 * secondsInMinute;
  const secondsInDay = 24 * secondsInHour;
  const secondsInMonth = 30 * secondsInDay; // Approximate, considering 30 days per month
  const secondsInYear = 12 * secondsInMonth;

  if (durationUnit) {
    switch (durationUnit) {
      case "second":
        return [durationInSeconds, "second"];
      case "minute":
        return [Math.floor(durationInSeconds / secondsInMinute), "minute"];
      case "hour":
        return [Math.floor(durationInSeconds / secondsInHour), "hour"];
      case "day":
        return [Math.floor(durationInSeconds / secondsInDay), "day"];
      case "month":
        return [Math.floor(durationInSeconds / secondsInMonth), "month"];
      case "year":
        return [Math.floor(durationInSeconds / secondsInYear), "year"];
      default:
        return [durationInSeconds, "second"]; // Fallback to seconds if unknown unit
    }
  }

  // Original logic to automatically determine the unit
  if (durationInSeconds < secondsInMinute) {
    return [durationInSeconds, "second"];
  } else if (durationInSeconds < secondsInHour) {
    const minutes = Math.floor(durationInSeconds / secondsInMinute);
    return [minutes, "minute"];
  } else if (durationInSeconds < secondsInDay) {
    const hours = Math.floor(durationInSeconds / secondsInHour);
    return [hours, "hour"];
  } else if (durationInSeconds < secondsInMonth) {
    const days = Math.floor(durationInSeconds / secondsInDay);
    return [days, "day"];
  } else if (durationInSeconds < secondsInYear) {
    const months = Math.floor(durationInSeconds / secondsInMonth);
    return [months, "month"];
  } else {
    const years = Math.floor(durationInSeconds / secondsInYear);
    return [years, "year"];
  }
};

export default formatDuration;